/* Feb-2026 · Pending Intents — fixes a mount-order race between the
 * Task Launcher / Synopsis Tools hub (which switch panels AND want to
 * trigger an action in the panel they just switched to) and the
 * target panel's own mount effect. A `window.dispatchEvent` fired in
 * the same tick as the panel-visibility toggle is lost if the panel
 * wasn't already mounted — these consume-once flags let the panel
 * check "was something waiting for me?" on mount, in addition to its
 * live event listener (which still covers the already-mounted case).
 */
let pendingSynopsisOpen = false;
let pendingChatPrompt = null;

export function setPendingSynopsisOpen() { pendingSynopsisOpen = true; }
export function consumePendingSynopsisOpen() {
  const v = pendingSynopsisOpen;
  pendingSynopsisOpen = false;
  return v;
}

export function setPendingChatPrompt(text) { pendingChatPrompt = text; }
export function consumePendingChatPrompt() {
  const v = pendingChatPrompt;
  pendingChatPrompt = null;
  return v;
}
